import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { ALLOWED_AZURE_GROUPS } from '../../const/allowedADGroups';

@Injectable({ providedIn: 'root' })
export class AuthGroupService {
    private msalService: MsalService = inject(MsalService);

    getResolvedAccount(): AccountInfo | null {
        const activeAccount = this.msalService.instance.getActiveAccount();
        if (activeAccount) {
            return activeAccount;
        }

        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length === 1) {
            this.msalService.instance.setActiveAccount(accounts[0]);
            return accounts[0];
        }

        return null;
    }

    hasRequiredAzureGroup(): boolean {
        const account = this.getResolvedAccount();
        if (!account) {
            return false;
        }

        const claims = account.idTokenClaims as { groups?: string[], hasgroups?: boolean } | undefined;
        if (claims?.hasgroups) {
            console.warn('User has too many groups for token claim');
            return false;
        }
        const groups: string[] = claims?.groups ?? [];
        return groups.some((group) => ALLOWED_AZURE_GROUPS.includes(group));
    }
}